import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import type {
  LoginInitialRequestDto,
  LoginMfaRequestDto,
} from '@/features/auth-login';
import { createLoginMfaFormSchema } from './loginSchema';
import { useEffect } from 'react';
import type { MFAIdentityType } from '@/entities/mfa-identity';

const useMfaForm = (
  loginArgs: LoginInitialRequestDto,
  mfaType: MFAIdentityType,
  mfaState: string
) => {
  const { t } = useTranslation();

  const schema = createLoginMfaFormSchema(t);

  const form = useForm<LoginMfaRequestDto>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    defaultValues: {
      login: loginArgs.login,
      password: loginArgs.password,
      twoFA: {
        state: mfaState,
        code: '',
        identityType: mfaType,
      },
      source: '',
    },
  });

  // Update error messages after changing the language
  useEffect(() => {
    if (form.formState.isSubmitted) {
      form.trigger();
    }
  }, [t]);

  const resetCode = () => {
    form.setValue('twoFA.code', '');
  };

  return {
    form,
    resetCode,
  };
};

export { useMfaForm };
